module.exports = __webpack_public_path__ + "static/img/IP-zl.a602a07f.png";